import {
  ADD_WLTR,
  DEL_WLTR,
  UPDATE_WLTR,
  CHANGE_WLTRSELROW,
  ADD_POMPTR,
  DEL_POMPTR,
  UPDATE_POMPTR,
  CHANGE_POMPTRSELROW,
  CHANGE_MEASELROW,
  CHANGE_MEATIMESELROW,
  CHANGE_DELTAT,
  ADD_OUTTIMETR,
  DEL_OUTTIMETR,
  UPDATE_OUTTIMETR,
  CHANGE_OUTTIMESELROW,
  UPDATE_LAKETR,
} from "./actions";

const initData = {
  wlTrData: [],
  pompTrData: [],
  deltaT: 0.01,
  outTimeTrData: [],
  lakeTrData: [],
};

export function wellReducer(state = initData, action) {
  switch (action.type) {
    case ADD_WLTR:
      return addWLTrReduce(state, action);
    case DEL_WLTR:
      return delWLTrReduce(state, action);
    case UPDATE_WLTR:
      return updateWLTrReduce(state, action);
    case CHANGE_WLTRSELROW:
      return changeWLTrSelRowReduce(state, action);
    case ADD_POMPTR:
      return addPompTrReduce(state, action);
    case DEL_POMPTR:
      return delPompTrReduce(state, action);
    case UPDATE_POMPTR:
      return updatePompTrReduce(state, action);
    case CHANGE_POMPTRSELROW:
      return changePompTrSelRowReduce(state, action);
    case CHANGE_MEASELROW:
      return changeMeaSelRowReduce(state, action);
    case CHANGE_MEATIMESELROW:
      return changeMeaTimeSelRowReduce(state, action);
    case CHANGE_DELTAT:
      return changeDeltaTReduce(state, action);
    case ADD_OUTTIMETR:
      return addOutTimeTrReduce(state, action);
    case DEL_OUTTIMETR:
      return delOutTimeTrReduce(state, action);
    case UPDATE_OUTTIMETR:
      return updateOutTimeTrReduce(state, action);
    case CHANGE_OUTTIMESELROW:
      return changeOutTimeTrSelRowReduce(state, action);
    case UPDATE_LAKETR:
      return updateLakeTrReduce(state, action);

    default:
      return state;
  }
}

export function addWLTrReduce(state, action) {
  return {
    ...state,
    wlTrData: state.wlTrData.concat({
      name: action.NAME,
      lat: action.LAT,
      lon: action.LON,
      mea: action.MEA,
      data: action.DATA,
    }),
  };
}

export function delWLTrReduce(state, action) {
  return {
    ...state,
    wlTrData: state.wlTrData.filter((el, index) => index !== action.rowID),
  };
}

export function updateWLTrReduce(state, action) {
  return {
    ...state,
    wlTrData: action.value,
  };
}

export function changeWLTrSelRowReduce(state, action) {
  return {
    ...state,
    wlTrSelRow: action.rowID,
  };
}

export function addPompTrReduce(state, action) {
  return {
    ...state,
    pompTrData: state.pompTrData.concat({
      name: action.NAME,
      lat: action.LAT,
      lon: action.LON,
      mea: action.MEA,
      data: action.DATA,
    }),
  };
}

export function delPompTrReduce(state, action) {
  return {
    ...state,
    pompTrData: state.pompTrData.filter((el, index) => index !== action.rowID),
  };
}

export function updatePompTrReduce(state, action) {
  return {
    ...state,
    pompTrData: action.value,
  };
}

export function changePompTrSelRowReduce(state, action) {
  return {
    ...state,
    pompTrSelRow: action.rowID,
  };
}

export function changeMeaSelRowReduce(state, action) {
  return {
    ...state,
    meaSelRow: action.value,
  };
}

export function changeMeaTimeSelRowReduce(state, action) {
  return {
    ...state,
    meaTimeSelRow: action.value,
  };
}

export function changeDeltaTReduce(state, action) {
  return {
    ...state,
    deltaT: action.value,
  };
}

export function addOutTimeTrReduce(state, action) {
  return {
    ...state,
    outTimeTrData: state.outTimeTrData.concat({ TIME: action.TIME }),
  };
}

export function delOutTimeTrReduce(state, action) {
  return {
    ...state,
    outTimeTrData: state.outTimeTrData.filter(
      (el, index) => index !== action.rowID
    ),
  };
}

export function updateOutTimeTrReduce(state, action) {
  return {
    ...state,
    outTimeTrData: action.value,
  };
}

export function changeOutTimeTrSelRowReduce(state, action) {
  return {
    ...state,
    outTimeTrSelRow: action.rowID,
  };
}

export function updateLakeTrReduce(state, action) {
  return {
    ...state,
    lakeTrData: action.value,
  };
}
